import { HTMLAttributes, CSSProperties } from 'react';
import Link from '@base/lib/ThemeLink';
import cn from 'classnames';
import { useProductContext } from 'mod/product-list/useProductContext';
import { Main } from 'mod/product-list/ProductPicture/Main';
import { QuickView } from 'mod/product-list/ProductPicture/QuickView';

export type IProductPictureProps = HTMLAttributes<HTMLDivElement>;

export const ProductPicture: Globals.FC<IProductPictureProps> = props => {
    const { product, link, picture = {}, canLinkJump } = useProductContext();
    const { className, onClick, ...rest } = props;
    const containerClassName = cn('relative g-picture js-picture', className);
    const { spaceAroundPicture = 0, spaceBelowPicture = 0, onQuickView } = picture;
    let containerStyle: CSSProperties = {};
    if (spaceAroundPicture > 0) {
        containerStyle.padding = spaceAroundPicture;
    }
    if (spaceBelowPicture > 0) {
        containerStyle.marginBottom = spaceBelowPicture;
    }

    if (link === false || !canLinkJump) {
        return (
            <div className={containerClassName} style={containerStyle} onClick={onClick}>
                <Main {...rest}/>
                {typeof onQuickView === 'function' && <QuickView variantId={product.variantId} onQuickView={onQuickView}/>}
            </div>
        )
    }
    if (typeof onQuickView === 'function') {
        return (
            <div className={containerClassName} style={containerStyle} onClick={onClick}>
                <Link href={product.url}>
                    <a tabIndex={-1} aria-hidden={true} className={'block js-track-link'}>
                        <Main {...rest}/>
                    </a>
                </Link>

                <QuickView variantId={product.variantId} onQuickView={onQuickView}/>
            </div>
        )
    }


    return (
        <Link href={product.url}>
            <a
                tabIndex={-1}
                aria-hidden={true}
                className={cn('relative block g-picture js-picture js-track-link', className)}
                style={containerStyle}
            >
                <Main {...rest}/>
            </a>
        </Link>
    )
};